var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaymentSignetPointsSurcharge = function SvgPaymentSignetPointsSurcharge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1 -1 20 18",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16v-5.36a2.639 2.639 0 1 1 0-5.28V0Z",
    fill: "url(#payment-signet-points-surcharge_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a8 8 0 1 1 0 16v-5.36a2.638 2.638 0 1 0 0-5.28V0Z",
    fill: "url(#payment-signet-points-surcharge_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "payment-signet-points-surcharge_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 16 -14.9247 0 8 8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#003EB8",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#003EB8",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "payment-signet-points-surcharge_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 16 -16.1252 0 10 8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#FF6D00",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#FF6D00",
    stopOpacity: 0.05
  })))));
};
export default SvgPaymentSignetPointsSurcharge;